import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const LogoutButton: React.FC = () => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    // Clear sessionStorage before logout
    sessionStorage.removeItem('jwt_token');
    sessionStorage.removeItem('user');
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <button
      onClick={handleLogout}
      className="btn-secondary px-4 py-2"
    >
      🚪 Logout
    </button>
  );
};

export default LogoutButton;
